import axios from 'axios';

export default {
	loadAbsence(absenceId) {
		return axios.get(`/api/absences/${absenceId}`);
	},
	loadReport(reportId) {
		return axios.get(`/api/reports/${reportId}`);
	},
	loadDay(dayId) {
		return axios.get(`/api/days/${dayId}?fields=date`);
	},
	loadDaysByIds(ids, fields) {
		return axios.post('/api/days/bulk', {
			ids,
			fields: fields ?? ['date'],
		});
	},
	loadFreeUsers(absenceId) {
		return axios.get(`/api/users/free/${absenceId}`);
	},
	updateNotification(notification) {
		return axios.patch(`/api/notifications/${notification._id}`, notification);
	},
	updateReport(report) {
		return axios.patch(`/api/reports/${report.id}`, report);
	},
	loadAlternativeSolutionFindDriver(dutyId) {
		return axios.post(`/api/roster/alternativeSolutions`, {
			action: 'findDriver',
			duty: dutyId,
		});
	},
	loadAlternativeSolutionOfDriver(dutyId, driverId) {
		return axios.post(`/api/roster/alternativeSolutions`, {
			action: 'evaluateAssignment',
			duty: dutyId,
			driver: driverId,
		});
	},
	evaluateExchange(dutyId, driverId) {
		return axios.post(`/api/roster/alternativeSolutions`, {
			action: 'evaluateExchange',
			duty: dutyId,
			driver: driverId,
		});
	},
	assignDuty(dutyId, driverId, type, day) {
		if (type !== undefined && day !== undefined) {
			let name = 'A';
			if (type === 'rest') {
				name = 'R';
			}
			return axios.post(`/api/duties`, { user: driverId, type, day, fixed: true, name });
		} else {
			return axios.patch(`/api/duties/${dutyId}`, {
				user: driverId,
				fixed: true,
			});
		}
	},
	loadAlternativeSolutionFindDuty(driverId, dayId) {
		return axios.post(`/api/roster/alternativeSolutions`, {
			driver: driverId,
			day: dayId,
			action: 'findDuty',
		});
	},
	loadDutiesFromDay(dayId) {
		return axios.get(`/api/duties?day=${dayId}`);
	},
	loadDutyForUserAndDay(user, day) {
		return axios.get(`/api/duties?from=${day}&to=${day}&user=${user}&fields=id`);
	},
	loadAlternativeSolutionOfDuty(dutyId, driverId, dayId = null) {
		return axios.post(`/api/roster/alternativeSolutions`, {
			driver: driverId,
			duty: dutyId,
			day: dayId,
			evaluateForDuty: true,
			action: 'evaluateAssignment',
		});
	},
	loadLastStatisticsOfYear(user, year) {
		return axios.post(`/api/statistics/last`, {
			user,
			year,
		});
	},
	setAllNotificationsToDone(type, userId, reason) {
		return axios.post(`/api/notifications/markAsDone`, {
			type,
			userId,
			reason,
		});
	},
	setExchangeStatus(id, status, approvalComment) {
		return axios.patch(`/api/exchange/${id}/status`, {
			status,
			approvalComment,
		});
	},
	loadExchange(id) {
		return axios.get(`/api/exchange/${id}`);
	},
	downloadDocumentById(id) {
		return axios.get(`/api/documents/${id}/download`, {
			responseType: 'blob',
		});
	},
	getDocumentByID(documentID) {
		return axios.get(`/api/documents/${documentID}`);
	},
};
